<template>
  <div class="row content">
    <div class="col-5">{{ title }}</div>
    <div class="col-4">
      <el-select
        v-if="options"
        :value="selectValue"
        placeholder="Pick one"
        @input="handleInputSelect"
      >
        <el-option-group
          v-for="group in options"
          :key="group.label"
          :label="group.label"
        >
          <el-option
            v-for="item in group.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-option-group>
      </el-select>
      <div v-else>-</div>
    </div>
    <div class="col-3">
      <button class="sc-btn sc-btn-outline" @click="exportReport">
        ดาวน์โหลดข้อมูล
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import { Select, Option, OptionGroup } from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import { getCookie, Auth } from "@/lib/cookie"

export default {
  components: {
    "el-select": Select,
    "el-option": Option,
    "el-option-group": OptionGroup,
  },
  props: {
    title: {
      type: null,
      default: undefined,
    },
    options: {
      type: null,
      default: undefined,
    },
    value: {
      type: null,
      default: undefined,
    },
    paramKey: {
      type: null,
      default: undefined,
    },
    filterDate: {
      type: null,
      default: undefined,
    },
    downloadEndpoint: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {}
  },
  computed: {
    selectValue() {
      return this.value
    },
  },
  methods: {
    handleInputSelect(value) {
      this.$emit("input", value)
    },
    async exportReport() {
      const exportUrl = `${process.env.HOST}${this.downloadEndpoint}`
      const params = {
        params: {
          format: "xlsx",
          from: moment(this.filterDate[0]).toISOString(),
          to: moment(this.filterDate[1]).toISOString(),
        },
        headers: {
          Accept: "application/octet-stream",
          Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
        },
        responseType: "blob",
      }

      if (this.paramKey) {
        if (this.selectValue) params.params[this.paramKey] = this.selectValue
        if (this.selectValue.split(",").length > 1)
          params.params[this.paramKey] = this.selectValue.split(",")
      }

      try {
        const exported = await axios.get(exportUrl, params)
        const blob = new Blob([exported.data], { type: "text/csv" })
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = `report-${this.title}-exported.xls`
        link.click()
      } catch (e) {
        this.$message.error("Report cannot downloaded")
        throw e
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.row {
  margin: 0;

  & > div {
    border-right: 1px solid #e0e0e0;
    padding: 12px 32px;
  }
}

.content {
  border-bottom: 1px solid #e0e0e0;
  align-self: stretch;

  & > div {
    vertical-align: middle;
  }
}
</style>
